<template>
  <img src="/images/promo/hero-section/round-pushpin.png"
   alt="Round Pushpin" />
</template>

<script>
export default {};
</script>
